<button
  mat-icon-button
  aria-label="Réglages"
  matTooltip="Réglages"
  [matMenuTriggerFor]="settingsMenu"
>
  <svg lucideSettings class="vanex-gold"></svg>
</button>

<mat-menu #settingsMenu="matMenu">
  <a mat-menu-item routerLink="/reglages/notifications">
    <svg lucideBell class="menu-icon"></svg>
    <span>Notifications</span>
  </a>
</mat-menu>
